/*
 * @Author: wangbaihe
 * @Date: 2025-07-17 09:35:12
 * @LastEditors: wangbaihe
 * @LastEditTime: 2026-03-18 13:46:24
 * @FilePath: \common-mediax\src\apis\MediaCloudJournal\ArticleEdit.js
 * @Description:  MediaCloudJournalArticleEdit
 */
import { createAPI } from '@common'

export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 获取所有能访问的刊物(可浏览
  getPermJournals: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0kpvsobmt', 'GET', config),

  // 获取所有能访问的刊物(可传入
  getSignJournals: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tjho0kpvsobmt', 'GET', config),
  // 签发-根据刊物id查询刊期(可传入
  getSignJournalDates: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tjho0ebuft', 'GET', config),
  // 根据刊物Id获取期刊可上栏的栏目(可传入
  getSignJournalColumns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobmQfsn0tjho0dpmvnot', 'GET', config),
  // 签发到期刊
  postJournalE5Listdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0tjho0gpsxbse', 'POST', config),
  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0f60bdujpot0mpht', 'GET', config, vconfig),
  // 小样详情
  getArticlesDetails: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0efubjm', 'GET', config, vconfig),
  getDetail: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0efubjm', 'GET', config, vconfig),
  // 稿源库-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0f60bdujpot0efubjmbdujpot', 'GET', config),
  // 打印期刊小样
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0qsjou', 'POST', config),
  // 期刊小样送制作
  putArticlePhotoMake: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0qipup0nblf',
      'PUT',
      config
    ),
  // 期刊小样取消送制作
  putArticlePhotoUnmake: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0qipup0vonblf',
      'PUT',
      config
    ),
  // 期刊小样送制作人员列表
  getArticlePhotoMakeUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0qipup0nblf0vtfst',
      'GET',
      config
    ),

  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 期刊小样整期下载
  postArticleDownloadAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0kpvsobmBsujdmfEpxompbeBmm',
      'POST',
      config
    ),
  // 根据刊物查询对应时间区间内的刊期
  getJournalDataByJournalAndDate: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0tzt0kpvsobm0ebuf0hfuKpvsobmEbubCzKpvsobmBoeEbuf',
      'GET',
      config,
      vconfig
    ),
  // 小样解锁
  postUnlock: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0vompdl',
      'POST',
      config
    ),
  // 小样送排
  postJournalArticleDelivery: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0efmjwfsz',
      'POST',
      config
    ),
  // 小样撤排
  postJournalArticleWithdraw: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0xjuiesbx',
      'POST',
      config
    ),
  // 小样退稿（退到部门库
  postJournalArticleRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0sfwplf',
      'POST',
      config
    ),
  // 获取小样图片地址
  getPhotosPath: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0qipupt0qbui', 'get', config, {
      timeout: 200000
    }),
  // 调栏目刊期接口
  postArticlesAjustJournalDate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0bkvtu0kpvsobmEbuf',
      'post',
      config
    ),
  // 写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0joju', 'get', config),
  // 写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0kpvsobm0bsujdmft0bdujpot0tbwf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0qbqfst0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到通用稿库
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到期刊
  postJournalArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0kpvsobm0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 小样导出
  putExport: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.kpvsobm0bsujdmft0fyqpsu', 'put', config, {
      timeout: 120000
    })
}
